import { IJamsContextData } from "./types";

export const jamsInitialState: IJamsContextData = {
  myJams: null,
  collabJams: null,
  users: {},
};
